export default {"src":"/_next/static/media/Sentry.80d900cc.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};